import React from 'react';
import {BaseComponent as Component} from 'BaseComponent';
import DownloadCheckedLineups from './components/download-checked-lineups';
import DownloadReoptimizedLineups from './components/download-reoptimized-lineups';
import RemoveCheckedLineups from './components/remove-checked-lineups';
import ShowUnexposedPlayers from './components/show-unexposed-players';
import CheckAllLineups from './components/check-all-lineups';
import SortLineups from './components/desktop/sort-lineups';
import {connect} from 'react-redux';
import GroupSameLineups from 'components/organisms/late-swap/components/group-same-lineups';

class LineupsDashboard extends Component {
    render() {
        const {lineups, sportConfig} = this.props;
        const lineupsQuantity = lineups.getCheckedQuantity();

        return (
            <div className="lineup-holder">
                <div className="lineup-filter">
                    <ShowUnexposedPlayers />
                </div>
                <div className="lineup-filter">
                    <CheckAllLineups />
                </div>
                <div className="lineup-filter lineup-sort">
                    <SortLineups />
                </div>
                <div className="lineup-filter">
                    <GroupSameLineups />
                </div>
                <div className="lineup-actions">
                    <RemoveCheckedLineups className={'btn btn-delete'}>
                        <i className="fa fa-trash"></i> Delete
                        <span className="small-text">
                            <span className="lineups-selected-counter">{lineupsQuantity}</span>&nbsp; Selected Lineups
                        </span>
                    </RemoveCheckedLineups>
                    {sportConfig.isModeLateswap() ? (
                        <DownloadReoptimizedLineups className={'btn btn-download download-lineups-csv'}>
                            <i className="fa fa-cloud-download"></i> DOWNLOAD
                            <span className="small-text">
                                CSV With&nbsp;
                                <span className="lineups-selected-counter">{lineupsQuantity}</span>&nbsp; Reoptimized
                                Lineups
                            </span>
                        </DownloadReoptimizedLineups>
                    ) : (
                        <DownloadCheckedLineups className={'btn btn-download download-lineups-csv'}>
                            <i className="fa fa-cloud-download"></i> DOWNLOAD
                            <span className="small-text">
                                CSV With&nbsp;
                                <span className="lineups-selected-counter">{lineupsQuantity}</span>&nbsp; Selected
                                Lineups
                            </span>
                        </DownloadCheckedLineups>
                    )}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData: {lineups},
        sportConfig,
    } = state;

    return {
        lineups,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(LineupsDashboard);
